import styled from 'styled-components';

// ICONS
import RatingStarIcon from '../../../../../stories/Icons/RatingStarIcon';

// Components
import {AltAccoStars} from '@stencil/gi-components/src/';

const StarIcon = styled(RatingStarIcon)(
  props => `
  color: ${props.theme.colors.goYellow.dark};
`,
);

const StarWrapper = styled.span`
  padding: 0 2px;
`;

const Star = () => (
  <StarWrapper>
    <StarIcon />
  </StarWrapper>
);

function HotelRatingStars({hotelRating, isAltAcco, isInternational}) {
  if (!hotelRating) {
    return null;
  }

  return (
    <span itemScope itemProp="starRating" itemType="http://schema.org/Rating">
      <meta itemProp="ratingValue" content={hotelRating} />
      {isAltAcco && !isInternational ? (
        <AltAccoStars hotelRating={hotelRating} />
      ) : (
        new Array(hotelRating).fill(1).map((_, i) => <Star key={'hotelStarDetailsDweb' + i} />)
      )}
    </span>
  );
}

export default HotelRatingStars;
